import { render, staticRenderFns } from "./BriqueChartModalDataGrid.vue?vue&type=template&id=7f21d7f4&"
import script from "./BriqueChartModalDataGrid.js?vue&type=script&lang=js&"
export * from "./BriqueChartModalDataGrid.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports